export default __webpack_public_path__ + "a05557d2a55e2f79bde1bc5dabbb5308.png";